import { combineReducers } from '@reduxjs/toolkit';
import { organizationReducer } from './Reducer/organizationReducer';
import { socketReducer } from './Reducer/socketReducer';

// Root Reducer
export const rootReducer = combineReducers({
  organization: organizationReducer,
  socket: socketReducer,
});

export default rootReducer;